import type { ReactNode } from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

export interface ERPBreadcrumbItem {
  key?: string;
  title: ReactNode;
  href?: string;
}

export interface ERPBreadcrumbProps {
  items: ERPBreadcrumbItem[];
}

const renderBreadcrumbItem = (item: ERPBreadcrumbItem, isLast: boolean) => {
  const label = <span className="erp-breadcrumb__label">{item.title}</span>;

  if (isLast) {
    return (
      <span aria-current="page" className="erp-breadcrumb__current">
        {label}
      </span>
    );
  }

  if (item.href) {
    return (
      <Link className="erp-breadcrumb__link" to={item.href}>
        {label}
      </Link>
    );
  }

  return <span className="erp-breadcrumb__text">{label}</span>;
};

export const ERPBreadcrumb = ({ items }: ERPBreadcrumbProps) => {
  if (items.length === 0) {
    return null;
  }

  const lastIndex = items.length - 1;

  return (
    <Breadcrumb className="erp-breadcrumb">
      {items.map((item, index) => (
        <Breadcrumb.Item key={item.key ?? String(index)}>
          {renderBreadcrumbItem(item, index === lastIndex)}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
